// Purpose: Route sponsor invitations into the shared business verification form.
// Dependencies: Scoped sponsor credentials and BusinessVerification.
// Behavior: Preserve sponsor callable contracts and ordinary optional account signup.
import React from "react";
import BusinessVerification from "../../components/business_verification";
import { getSponsorVerificationInvite } from "../../utils/sponsor_verification_invite";

export default function SponsorVerification() {
  return <BusinessVerification family="sponsor" getInvite={getSponsorVerificationInvite} />;
}
